// SideMenu.tsx
import SideDownIcon from '@pancakeswap/uikit/components/Svg/Icons/SideDownIcon'
import SideIconActiveBlur from '@pancakeswap/uikit/components/Svg/Icons/SideIconActiveBlur'
import { useRouter } from 'next/router'
import { MouseEvent, useMemo } from 'react'
import {
  BlurIconWrapper,
  IconWrapper,
  MenuItemWrapper,
  MenuText,
  SideDownIconWrapper,
  SideItemWrapper,
  SideMenuItem,
  SubIconWrapper,
  SubMenuItem,
  SubMenuWrapper,
} from '../styled'
import { MenuItem } from '../types'

interface Props {
  item: MenuItem
}
export default function SideMenu({ item }: Props) {
  const Icon = item.icon
  const hasChildren = !!item.children?.length
  const router = useRouter()

  const handleClick = (event: MouseEvent<HTMLElement>, path) => {
    event.stopPropagation()
    router.push(path)
  }
  const isActive = useMemo(() => {
    if (item.children) return !!item.children.find((each) => router.route.includes(each.path))
    return item.path === router.route
  }, [router, item])

  return (
    <SideItemWrapper $isActive={isActive} onClick={(e) => handleClick(e, item.path)}>
      <SideMenuItem $isActive={isActive}>
        <MenuItemWrapper>
          <IconWrapper isActive={isActive}>{Icon && <Icon isActive={isActive} />}</IconWrapper>
          <MenuText isActive={isActive}>{item.label}</MenuText>
        </MenuItemWrapper>
        {hasChildren && (
          <SideDownIconWrapper>
            <SideDownIcon />
          </SideDownIconWrapper>
        )}
      </SideMenuItem>

      {item.children && (
        <SubMenuWrapper $isActive={isActive}>
          {item.children.map((child) => {
            const ChildIcon = child.icon
            const isChildActive = child.path === router.route

            return (
              <SubMenuItem key={child.id} isActive={isChildActive} onClick={(e) => handleClick(e, child.path)}>
                <SubIconWrapper isActive={isChildActive}>
                  {isChildActive && (
                    <BlurIconWrapper>
                      <SideIconActiveBlur />
                    </BlurIconWrapper>
                  )}
                  {ChildIcon && <ChildIcon isActive={isChildActive} />}
                </SubIconWrapper>
                <MenuText isActive={isChildActive}>{child.label}</MenuText>
              </SubMenuItem>
            )
          })}
        </SubMenuWrapper>
      )}
    </SideItemWrapper>
  )
}
